/** @typedef {String} PathifiedSvgContent */
/** @typedef {String} FeatherIconsPathDefinition */
/** @typedef {{ prefix: 'fe', iconName: 'feDivide', icon: [Number|String, Number|String, import('feather-icons').FeatherAttributes, PathifiedSvgContent, FeatherIconsPathDefinition] }} FeatherDivideIconData */

/** @type {FeatherDivideIconData} */
const feDivide = {
  prefix: 'fe',
  iconName: 'divide',
  icon: [
    24,
    24,
    '<circle cx="12" cy="6" r="2"></circle><line x1="5" y1="12" x2="19" y2="12"></line><circle cx="12" cy="18" r="2"></circle>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-divide"><path d="M14 6 A2 2 0 0 1 12 8 A2 2 0 0 1 10 6 A2 2 0 0 1 14 6 z"/><path d="M5 12 L19 12"/><path d="M14 18 A2 2 0 0 1 12 20 A2 2 0 0 1 10 18 A2 2 0 0 1 14 18 z"/></svg>',
    'M14 6 A2 2 0 0 1 12 8 A2 2 0 0 1 10 6 A2 2 0 0 1 14 6 z M5 12 L19 12 M14 18 A2 2 0 0 1 12 20 A2 2 0 0 1 10 18 A2 2 0 0 1 14 18 z',
    '"xmlns"="http=//www.w3.org/2000/svg" "width"="24" "height"="24" "fill"="none" "stroke"="currentColor" "stroke-width"=2 "stroke-linecap"="round" "stroke-linejoin"="round"',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: 24,
      height: 24,
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 2,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    },
  ],
}

export default feDivide
